import { Reveal } from "../components/Reveal";
import { Mole } from "../components/Mole";

const EMAIL_RE = /(info@nora-vpn\.com|support@nora-vpn\.com)/g;

const linkify = (text, subject) =>
  text.split(EMAIL_RE).map((part, i) =>
    part.includes("@") ? (
      <a
        key={i}
        href={`mailto:${part}${subject ? `?subject=${encodeURIComponent(subject)}` : ""}`}
        className="font-semibold text-nora-accent hover:underline"
      >
        {part}
      </a>
    ) : (
      part
    ),
  );

const TERMS_SECTIONS = [
  {
    h: "1. Общие положения",
    parts: [
      { type: "p", text: "1.1. Настоящий документ является публичной офертой (далее «Оферта») Индивидуального предпринимателя Фарход Максимов (Individual Entrepreneur FARKHOD MAKSIMOV), идентификационный номер 305873551, зарегистрированного Национальным агентством публичного реестра Министерства юстиции Грузии (далее «Провайдер»), адресованной любому физическому лицу (далее «Пользователь»), о заключении договора на предоставление доступа к VPN-сервису NORA (далее «Сервис») на условиях, изложенных ниже." },
      { type: "p", text: "1.2. Акцептом Оферты является любое из следующих действий: активация пробного периода, оплата подписки, начало использования Сервиса. С момента акцепта договор считается заключенным. Акцепт Оферты в электронной форме приравнивается к заключению договора в письменной форме." },
      { type: "p", text: "1.3. Пользователь подтверждает, что до акцепта ознакомился с Офертой и Политикой конфиденциальности и принимает их условия полностью и без оговорок." },
      { type: "p", text: "1.4. Пользователь подтверждает, что достиг возраста, с которого вправе самостоятельно заключать такие договоры по законодательству страны своего проживания, либо действует с согласия законного представителя." },
    ],
  },
  {
    h: "2. Предмет договора",
    parts: [
      { type: "p", text: "2.1. Провайдер предоставляет Пользователю доступ к Сервису: приложению для установления защищенного VPN-соединения на устройствах iOS, Android и Windows, а Пользователь оплачивает доступ в соответствии с выбранным тарифом." },
      { type: "p", text: "2.2. Одна подписка действует на всех устройствах Пользователя, на которых выполнен вход в один аккаунт, но не более чем на 3 (трех) устройствах одновременно." },
      { type: "p", text: "2.3. Перечень серверов, стран и функций Сервиса может изменяться. Провайдер вправе изменять состав функций Сервиса без существенного ухудшения его основных характеристик в течение оплаченного периода." },
    ],
  },
  {
    h: "3. Тарифы и порядок оплаты",
    parts: [
      { type: "p", text: "3.1. Тарифы:" },
      { type: "ul", items: [
        "1 месяц — 449 ₽ в месяц (449 ₽ за период)",
        "6 месяцев — 299 ₽ в месяц (1 794 ₽ за период)",
        "12 месяцев — 219 ₽ в месяц (2 628 ₽ за период)",
      ] },
      { type: "p", text: "3.2. Цены указаны в российских рублях. Фактическая стоимость, валюта списания и применимые налоги определяются платформой App Store или Google Play в зависимости от страны аккаунта Пользователя и отображаются Пользователю до оплаты." },
      { type: "p", text: "3.3. Оплата производится через App Store (Apple) или Google Play (Google). Apple и Google выступают платежными агентами Провайдера. Провайдер не получает и не хранит данные банковских карт Пользователя." },
      { type: "p", text: "3.4. Подписка продлевается автоматически на тот же срок, если Пользователь не отменил автопродление в настройках своего аккаунта App Store или Google Play до окончания текущего оплаченного периода в порядке, установленном соответствующей платформой." },
      { type: "p", text: "3.5. Дополнительные платные функции Сервиса (в том числе Про-режим) предоставляются по отдельным тарифам, указанным в приложении." },
      { type: "p", text: "3.6. Провайдер вправе изменять тарифы. Новые тарифы не применяются к уже оплаченному периоду." },
    ],
  },
  {
    h: "4. Пробный период",
    parts: [
      { type: "p", text: "4.1. Каждому новому Пользователю предоставляется 1 (один) день бесплатного доступа к Сервису (пробный период)." },
      { type: "p", text: "4.2. Пробный период предоставляется один раз на одного человека и привязывается к аккаунту Apple или Google. Провайдер вправе отказать в предоставлении пробного периода при признаках его повторного получения, в том числе через создание новых аккаунтов." },
      { type: "p", text: "4.3. Если пробный период оформлен в составе подписки через App Store или Google Play, по его окончании подписка продлевается автоматически по выбранному тарифу, если Пользователь не отменил ее до окончания пробного периода." },
    ],
  },
  {
    h: "5. Реферальная программа",
    parts: [
      { type: "p", text: "5.1. Каждый Пользователь получает в приложении персональную реферальную ссылку." },
      { type: "p", text: "5.2. Новый Пользователь, впервые зарегистрировавшийся в Сервисе по реферальной ссылке, получает 3 (три) дня бесплатного доступа." },
      { type: "p", text: "5.3. Пользователь, по чьей реферальной ссылке зарегистрировался новый Пользователь, получает 5 (пять) дней бесплатного доступа за каждого такого нового Пользователя." },
      { type: "p", text: "5.4. Бесплатный пробный день и бесплатные дни по реферальной программе не суммируются: новый Пользователь, пришедший по реферальной ссылке, получает 3 дня вместо стандартного пробного дня." },
      { type: "p", text: "5.5. Все начисленные бонусные дни отображаются в личном кабинете Пользователя в приложении." },
      { type: "p", text: "5.6. Бонусные дни не подлежат обмену на денежные средства и передаче третьим лицам." },
      { type: "p", text: "5.7. Провайдер вправе аннулировать бонусные дни и ограничить участие Пользователя в реферальной программе при выявлении злоупотреблений, включая регистрацию фиктивных аккаунтов и регистрацию по собственной реферальной ссылке." },
      { type: "p", text: "5.8. Провайдер вправе изменить или прекратить реферальную программу, уведомив Пользователей в приложении. Бонусные дни, начисленные до изменения, сохраняются." },
    ],
  },
  {
    h: "6. Отмена подписки и возврат средств",
    parts: [
      { type: "p", text: "6.1. Пользователь может отменить подписку в любой момент в настройках своего аккаунта App Store или Google Play. Доступ к Сервису сохраняется до окончания оплаченного периода." },
      { type: "p", text: "6.2. Возврат денежных средств осуществляется в соответствии с правилами и политиками возврата App Store (Apple) и Google Play (Google), которые выступают платежными агентами Провайдера. Запрос на возврат Пользователь направляет непосредственно в Apple или Google." },
      { type: "p", text: "6.3. Сервис предоставляется в цифровой форме, не на материальном носителе. Оформляя подписку, Пользователь дает явное согласие на немедленное начало предоставления доступа к Сервису в течение срока, установленного для отказа от договора, и подтверждает, что уведомлен: с началом предоставления доступа право на отказ от договора в течение 14 календарных дней утрачивается, а в случаях, когда законом предусмотрено иное, при отказе подлежит оплате стоимость фактически предоставленного доступа." },
    ],
  },
  {
    h: "7. Права и обязанности Пользователя",
    parts: [
      { type: "p", text: "7.1. Пользователь обязуется:" },
      { type: "ul", items: [
        "использовать Сервис в соответствии с законодательством страны своего нахождения и самостоятельно нести ответственность за соблюдение местных норм, регулирующих использование VPN-сервисов;",
        "не использовать Сервис для противоправной деятельности, в том числе для распространения вредоносного программного обеспечения, мошенничества, рассылки спама и нарушения прав третьих лиц;",
        "не передавать доступ к своему аккаунту третьим лицам и не превышать допустимое количество устройств;",
        "не предпринимать попыток вмешательства в работу Сервиса и его инфраструктуры.",
      ] },
      { type: "p", text: "7.2. При нарушении пункта 7.1 Провайдер вправе приостановить или прекратить доступ Пользователя к Сервису. В этом случае оплата за текущий период не возвращается, за исключением случаев, предусмотренных пунктом 6.2." },
    ],
  },
  {
    h: "8. Ограничение ответственности",
    parts: [
      { type: "p", text: "8.1. Сервис предоставляется «как есть». Провайдер прилагает разумные усилия для бесперебойной работы Сервиса, но не гарантирует его непрерывную и безошибочную работу, а также доступность отдельных сайтов и сервисов через VPN-соединение." },
      { type: "p", text: "8.2. Провайдер не несет ответственности за:" },
      { type: "ul", items: [
        "действия Пользователя в интернете во время использования Сервиса;",
        "содержимое сайтов и сервисов, к которым обращается Пользователь;",
        "работу и безопасность сторонних серверов, подключенных Пользователем через функцию «Свой сервер»;",
        "перебои, вызванные действиями операторов связи, платформ Apple и Google, а также иных третьих лиц.",
      ] },
      { type: "p", text: "8.3. Совокупная ответственность Провайдера перед Пользователем ограничивается суммой, фактически уплаченной Пользователем за текущий оплаченный период подписки. Провайдер не возмещает упущенную выгоду и косвенные убытки." },
      { type: "p", text: "8.4. Ограничения, установленные настоящим разделом, не применяются в случаях умысла или грубой неосторожности Провайдера, а также в иных случаях, когда такие ограничения не допускаются законодательством Грузии." },
    ],
  },
  {
    h: "9. Обстоятельства непреодолимой силы",
    parts: [
      { type: "p", text: "9.1. Провайдер освобождается от ответственности за полное или частичное неисполнение обязательств, если оно вызвано обстоятельствами непреодолимой силы, включая: решения и действия государственных органов любой страны, в том числе ограничение или блокировку VPN-протоколов, сервисов и сетевых ресурсов; действия операторов связи и интернет-провайдеров; решения платформ App Store и Google Play; сбои дата-центров и хостинг-провайдеров; кибератаки; стихийные бедствия, военные действия и массовые беспорядки." },
      { type: "p", text: "9.2. Недоступность Сервиса на территории отдельной страны вследствие действий ее государственных органов не является основанием для возврата оплаты сверх случаев, предусмотренных пунктом 6.2." },
    ],
  },
  {
    h: "10. Персональные данные",
    parts: [
      { type: "p", text: "10.1. Обработка персональных данных Пользователя осуществляется в соответствии с Законом Грузии «О защите персональных данных» и Политикой конфиденциальности, размещенной по адресу: https://nora-vpn.com/privacy" },
    ],
  },
  {
    h: "11. Интеллектуальная собственность",
    parts: [
      { type: "p", text: "11.1. Права на приложение NORA, его программный код, дизайн, название, товарные знаки и фирменного персонажа принадлежат Провайдеру. Пользователю предоставляется ограниченное, неисключительное и непередаваемое право использования приложения в личных некоммерческих целях на срок действия подписки или пробного периода." },
      { type: "p", text: "11.2. Запрещается копирование, декомпиляция, модификация и распространение приложения без письменного согласия Провайдера." },
    ],
  },
  {
    h: "12. Применимое право и разрешение споров",
    parts: [
      { type: "p", text: "12.1. Настоящая Оферта и отношения между Провайдером и Пользователем регулируются законодательством Грузии. Выбор применимого права сделан сторонами в соответствии с Законом Грузии «О международном частном праве»." },
      { type: "p", text: "12.2. Стороны обязуются урегулировать споры путем переговоров. До обращения в суд Пользователь обязан направить Провайдеру письменную претензию на адрес info@nora-vpn.com с указанием адреса электронной почты аккаунта, сути требования и подтверждающих документов. Провайдер рассматривает претензию и направляет ответ в течение 30 (тридцати) календарных дней с даты ее получения. Соблюдение претензионного порядка является обязательным." },
      { type: "p", text: "12.3. Требования, связанные с оплатой и возвратом денежных средств, Пользователь направляет в App Store или Google Play в соответствии с их правилами (пункт 6.2)." },
      { type: "p", text: "12.4. Если спор не урегулирован в претензионном порядке, он подлежит рассмотрению в суде Грузии по месту нахождения Провайдера: в Тбилисском городском суде. Стороны договорились о подсудности спора судам Грузии в соответствии с Законом Грузии «О международном частном праве»." },
      { type: "p", text: "12.5. Положения настоящей Оферты не ограничивают права Пользователя, предоставленные ему императивными нормами законодательства о защите прав потребителей." },
      { type: "p", text: "12.6. Оферта составлена на русском языке. В случае перевода Оферты на другие языки приоритет имеет текст на русском языке." },
      { type: "p", text: "12.7. Если какое-либо положение Оферты будет признано недействительным, это не влияет на действительность остальных положений." },
    ],
  },
  {
    h: "13. Изменение условий Оферты",
    parts: [
      { type: "p", text: "13.1. Провайдер вправе изменять условия Оферты. Новая редакция вступает в силу через 10 (десять) календарных дней после ее размещения на сайте nora-vpn.com, если иное не указано в новой редакции. О существенных изменениях Провайдер дополнительно уведомляет Пользователей в приложении." },
      { type: "p", text: "13.2. Продолжение использования Сервиса после вступления изменений в силу означает согласие Пользователя с новой редакцией. Если Пользователь не согласен с изменениями, он вправе отменить подписку в порядке, предусмотренном пунктом 6.1." },
    ],
  },
  {
    h: "14. Реквизиты Провайдера",
    parts: [
      { type: "ul", items: [
        "Индивидуальный предприниматель Фарход Максимов (Individual Entrepreneur FARKHOD MAKSIMOV)",
        "Идентификационный номер: 305873551",
        "Регистрирующий орган: Национальное агентство публичного реестра Министерства юстиции Грузии, дата регистрации 22.07.2026",
        "Юридический адрес: Грузия, г. Тбилиси, район Сабуртало, ул. Бахтриони, д. 22, кв. 75, 0160",
        "Email: info@nora-vpn.com",
        "Телефон: +995 568 81 54 05",
        "Сайт: https://nora-vpn.com",
      ] },
    ],
  },
];

const PAGES = {
  privacy: {
    title: "Конфиденциальность",
    subtitle: "Редакция от 10.10.2026",
    sections: [
      {
        h: "1. Кто мы",
        parts: [
          { type: "p", text: "NORA — VPN-приложение, разработанное и предоставляемое Individual Entrepreneur FARKHOD MAKSIMOV (Грузия, Тбилиси)." },
          { type: "p", text: "По вопросам, связанным с этой политикой, можно написать на info@nora-vpn.com." },
        ],
      },
      {
        h: "2. Какие данные мы собираем",
        parts: [
          { type: "p", text: "При установке VPN-соединения наша система в реальном времени обрабатывает:" },
          { type: "ul", items: ["IP-адрес устройства", "Время подключения", "Выбранный сервер"] },
          { type: "p", text: "Эта информация нужна только для того, чтобы техническое подключение состоялось, и не сохраняется и не логируется — после завершения сессии эти данные не хранятся у нас ни в каком виде." },
          { type: "p", text: "Мы также не записываем и не храним, какие сайты вы посещаете, какими приложениями пользуетесь или что делаете в интернете во время работы VPN." },
          { type: "p", text: "Если вы входите в приложение через Apple ID или Google-аккаунт, мы получаем от Apple/Google идентификатор аккаунта, необходимый для синхронизации устройств, работы триала и реферальной программы. Мы не запрашиваем и не получаем от Apple/Google доступ к вашей остальной личной информации сверх этого." },
          { type: "p", text: "Данные об оплате (номер карты и т.п.) мы не видим и не храним — все платежи обрабатываются напрямую Apple App Store или Google Play в соответствии с их собственными политиками конфиденциальности." },
        ],
      },
      {
        h: "3. Зачем мы это собираем",
        parts: [
          { type: "ul", items: [
            "Чтобы VPN-соединение технически работало",
            "Для защиты сервиса от злоупотреблений и атак",
            "Для диагностики проблем с подключением, если вы обращаетесь в поддержку",
            "Для управления подпиской, триалом и реферальной программой",
          ] },
        ],
      },
      {
        h: "4. Срок хранения",
        parts: [
          { type: "p", text: "Данные о подключении (IP-адрес, время, выбранный сервер) не хранятся вообще — они используются только в моменте, пока длится сессия, для технической работы соединения, и не сохраняются после её завершения." },
          { type: "p", text: "Данные аккаунта (идентификатор Apple/Google, статус подписки и триала) хранятся, пока существует ваш аккаунт, и удаляются по запросу (см. раздел 6)." },
        ],
      },
      {
        h: "5. Передача данных третьим лицам",
        parts: [
          { type: "p", text: "Мы не передаём ваши данные никаким третьим лицам, за исключением Apple и Google — и только в объёме, необходимом для обработки платежей через App Store и Google Play. Мы не используем сторонние сервисы аналитики или сбора статистики использования приложения." },
        ],
      },
      {
        h: "6. Ваши права",
        parts: [
          { type: "p", text: "Вы можете в любой момент запросить удаление своего аккаунта и связанных с ним данных, написав на info@nora-vpn.com." },
        ],
      },
      {
        h: "7. Возраст",
        parts: [
          { type: "p", text: "NORA не предназначена для лиц младше 16 лет. Если вам меньше 16 лет, пожалуйста, не используйте приложение без согласия родителей или опекунов." },
        ],
      },
      {
        h: "8. Изменения политики",
        parts: [
          { type: "p", text: "Если мы изменим эту политику, мы уведомим об этом через приложение или на сайте nora-vpn.com до вступления изменений в силу." },
        ],
      },
      {
        h: "9. Применимое право",
        parts: [
          { type: "p", text: "Эта политика регулируется законодательством Грузии, где зарегистрирован владелец сервиса." },
        ],
      },
    ],
  },
  terms: {
    title: "Публичная оферта",
    subtitle: "на предоставление доступа к сервису NORA · Редакция от 10.10.2026",
    sections: TERMS_SECTIONS,
  },
  support: {
    title: "Поддержка",
    sections: [
      {
        h: "Как связаться",
        parts: [{ type: "p", text: "Напишите нам на info@nora-vpn.com — обычно отвечаем в течение дня." }],
      },
      {
        h: "Новости и статус сервиса",
        parts: [{ type: "p", text: "Все новости, обновления и сообщения о сбоях мы публикуем в нашем Телеграм-канале. Если что-то не работает — там уже может быть ответ." }],
        link: { href: "https://t.me/NORAVPNcom", label: "Открыть Телеграм-канал" },
      },
      {
        h: "Что указать в письме",
        parts: [{ type: "p", text: "Опишите, что случилось, и приложите скриншот, если есть. Разбираться в технических деталях не нужно — просто расскажите, как есть." }],
      },
      {
        h: "Сначала загляните в вопросы",
        parts: [{ type: "p", text: "На главной странице есть ответы на самые частые вопросы — возможно, решение уже там." }],
        link: { href: "/#faq", label: "Открыть вопросы на главной" },
      },
    ],
  },
  "delete-account": {
    title: "Удаление аккаунта НОРА",
    subtitle: "Delete your NORA VPN account",
    intro:
      "На этой странице описано, как удалить аккаунт в приложении НОРА (NORA VPN) и связанные с ним данные. Сервис предоставляет Individual Entrepreneur FARKHOD MAKSIMOV, Грузия.",
    mailtoSubject: "Удаление аккаунта",
    enMailtoSubject: "Delete account",
    sections: [
      {
        h: "Как удалить аккаунт",
        parts: [
          { type: "ol", items: [
            "Откройте приложение, зайдите в «Настройки» и скопируйте идентификатор аккаунта. Он выглядит так: id_xxxxxxxxxxxx.",
            "Напишите на info@nora-vpn.com с темой «Удаление аккаунта» и укажите этот идентификатор.",
            "Мы удалим аккаунт и данные в течение 10 рабочих дней и подтвердим это ответным письмом.",
          ] },
        ],
      },
      {
        h: "Что будет удалено",
        parts: [
          { type: "ul", items: [
            "идентификатор аккаунта;",
            "привязка аккаунта Google или Apple, если она была;",
            "статус подписки и пробного периода;",
            "реферальный код, сведения о введенном коде друга и бонусные дни.",
          ] },
        ],
      },
      {
        h: "Что важно знать",
        parts: [
          { type: "ul", items: [
            "Удаление аккаунта не отменяет подписку. Сначала отмените ее в настройках Google Play или App Store, иначе списания продолжатся.",
            "Сведения о платежах хранят Google Play и App Store по своим правилам. Мы их не получаем и удалить не можем.",
            "Данные о подключениях (IP-адрес, время, сервер) мы не храним, поэтому удалять нечего.",
            "Удаленный аккаунт и бонусные дни восстановить нельзя.",
          ] },
        ],
      },
    ],
    smallprint:
      'To delete your NORA VPN account and all associated data, email info@nora-vpn.com with the subject "Delete account" and your account ID from the app Settings (id_xxxxxxxxxxxx). We delete the account ID, linked Google or Apple identifier, subscription and trial status, referral code and bonus days within 10 working days. Cancel your subscription in Google Play or the App Store first: deleting the account does not cancel it.',
  },
};

export default function LegalPage({ page }) {
  const p = PAGES[page];
  return (
    <main className="mx-auto max-w-2xl px-4 pb-20 pt-28 sm:px-6 sm:pt-36">
      <Reveal>
        <Mole variant="hi" className="w-16" />
        <h1
          data-testid={`legal-${page}-title`}
          className="mt-6 font-display text-3xl font-black tracking-tight sm:text-4xl"
        >
          {p.title}
        </h1>
        {p.subtitle && (
          <p className="mt-3 text-sm text-nora-ink/55">{p.subtitle}</p>
        )}
        {p.intro && (
          <p
            data-testid={`legal-${page}-intro`}
            className="mt-6 leading-relaxed text-nora-ink/70"
          >
            {linkify(p.intro, p.mailtoSubject)}
          </p>
        )}
      </Reveal>
      <div className="mt-8 space-y-4">
        {p.sections.map((s, i) => (
          <Reveal key={s.h} delay={0.05 * i}>
            <section
              data-testid={`legal-${page}-section-${i + 1}`}
              className="rounded-[1.5rem] border border-nora-ink/5 bg-nora-surface p-6 shadow-sm sm:p-8"
            >
              <h2 className="font-display text-lg font-bold">{s.h}</h2>
              <div className="mt-2 space-y-3">
                {s.parts.map((part, j) =>
                  part.type === "ol" ? (
                    <ol
                      key={j}
                      className="list-decimal space-y-1.5 pl-5 leading-relaxed text-nora-ink/70 marker:text-nora-accent"
                    >
                      {part.items.map((item) => (
                        <li key={item}>{linkify(item, p.mailtoSubject)}</li>
                      ))}
                    </ol>
                  ) : part.type === "ul" ? (
                    <ul
                      key={j}
                      className="list-disc space-y-1.5 pl-5 leading-relaxed text-nora-ink/70 marker:text-nora-accent"
                    >
                      {part.items.map((item) => (
                        <li key={item}>{linkify(item, p.mailtoSubject)}</li>
                      ))}
                    </ul>
                  ) : (
                    <p key={j} className="leading-relaxed text-nora-ink/70">
                      {linkify(part.text, p.mailtoSubject)}
                    </p>
                  ),
                )}
              </div>
              {s.link && (
                <a
                  href={s.link.href}
                  data-testid={`legal-${page}-link`}
                  {...(s.link.href.startsWith("http")
                    ? { target: "_blank", rel: "noopener noreferrer" }
                    : {})}
                  className="mt-3 inline-block font-semibold text-nora-accent hover:underline"
                >
                  {s.link.label}
                </a>
              )}
            </section>
          </Reveal>
        ))}
      </div>
      {p.smallprint && (
        <Reveal delay={0.05 * p.sections.length}>
          <p
            data-testid={`legal-${page}-smallprint`}
            className="mt-6 text-xs leading-relaxed text-nora-ink/45"
          >
            {linkify(p.smallprint, p.enMailtoSubject)}
          </p>
        </Reveal>
      )}
    </main>
  );
}
